import type { User } from '@libs/contexts';
import { Box, Menu, TextField } from '@mui/material';
import { useState } from 'react';
import { CompanyMenuItem } from './CompanyMenuItem';

interface CompanyMenuProps {
  user: User;
  anchorEl: HTMLElement | null;
  setAnchorEl: (el: HTMLElement | null) => void;
}

export function CompanyMenu(props: CompanyMenuProps) {
  const { user, anchorEl, setAnchorEl } = props;
  const [currentValid, setCurrentValid] = useState<number | null>(null);
  const [searchText, setSearchText] = useState('');

  const filteredCompanies = user.availableCompanies.filter(
    (c) =>
      c.name.toLowerCase().includes(searchText.toLowerCase()) ||
      c.code.toLowerCase().includes(searchText.toLowerCase()),
  );

  const onClose = () => {
    setCurrentValid(null);
    setAnchorEl(null);
    setSearchText('');
  };

  return (
    <Menu
      anchorEl={anchorEl}
      id="company-menu"
      open={Boolean(anchorEl)}
      onClose={onClose}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      transitionDuration={0}
      MenuListProps={{
        disablePadding: true,
      }}
      sx={{ width: '300px' }}
    >
      <Box
        sx={{
          p: 1,
          width: '300px',
          bgcolor: 'background.paper',
          position: 'sticky',
          top: 0,
          zIndex: 1,
        }}
      >
        <TextField
          size="small"
          placeholder="会社を検索"
          slotProps={{
            htmlInput: {
              maxLength: 40,
            },
          }}
          onChange={(newValue) => setSearchText(newValue.target.value)}
          onKeyDown={(e) => {
            e.stopPropagation();
          }}
        />
      </Box>
      {filteredCompanies.map((c, i) => (
        <CompanyMenuItem
          key={c.code}
          index={i}
          setCurrentValid={setCurrentValid}
          currentValid={currentValid}
          companyCode={c.code}
          companyName={c.name}
          regions={c.availableRegions}
          onClose={onClose}
        />
      ))}
    </Menu>
  );
}
